import { registerPlugin } from '@capacitor/core';
import type { CapacitorPluginScePlugin } from './definitions';

const CapacitorPluginSce = registerPlugin<CapacitorPluginScePlugin>('CapacitorPluginSce');


export * from './definitions';
export { CapacitorPluginSce };

